import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const queriesApi = createAsyncThunk(
  "queries",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    // const response = await axiosInstance.get("/queryList",{ params });
    const response = await axiosInstance.get("/queryList", { params });
    return response.data;
  }
);

const queriesSlice = createSlice({
  name: "queries",
  initialState: {
    queries: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(queriesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(queriesApi.fulfilled, (state, action) => {
        state.queries = action.payload;
        state.loading = false;
      })
      .addCase(queriesApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default queriesSlice.reducer;
